import axios from 'axios';

// const isStage = window.location.hostname.includes('stage');
// const isStage = true;

const axiosInstanceVendor = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_ADMIN,
  headers: {
    'Content-Type': 'application/json',
    'Content-Language': 'browser',
  },
});

axiosInstanceVendor.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  config.headers.token = token;
  return config;
});

axiosInstanceVendor.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
  }
);
export default axiosInstanceVendor;
